import React from 'react';
import { Skeleton, Stack, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    width: '100%',

    [theme.fn.smallerThan('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing.md,
      textAlign: 'center',
    },
  },
}));

function ReviveEntryLoadingScreen() {
  const { classes } = useStyles();

  return (
    <Stack align="center">
      <Skeleton height={30} width={200} />
      <Skeleton height={20} maw={400} />
      <Skeleton height={20} width={100} />

      <Skeleton height={40} width={200} />

      <div className={classes.footer}>
        <Skeleton height={48} width="100%" />
      </div>
    </Stack>
  );
}

export default ReviveEntryLoadingScreen;
